module.exports = __webpack_public_path__ + "img/1503921457.9242934f.jpg";